import { render, staticRenderFns } from "./navigationbutton.vue?vue&type=template&id=7d27c72b&scoped=true&"
import script from "./navigationbutton.vue?vue&type=script&lang=js&"
export * from "./navigationbutton.vue?vue&type=script&lang=js&"
import style0 from "./navigationbutton.vue?vue&type=style&index=0&id=7d27c72b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d27c72b",
  null
  
)

export default component.exports